<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">
        Reversar ultima carga
      </b-card-header>
      <b-card-body v-if="!model.viewResult">
        <div class="col-md-12 text-center">
          <img
            src="@/assets/cargatjt.png"
            style="max-width: 250px; max-height: 250px"
          />
          <h1 style="color: #ff5855">¿Desea reversar la ultima carga?</h1>
          
            <div class="col-md-12">
              <label>Feha/Hora: {{ model.FormatttedDateTime }}</label>
            </div>
            <div class="col-md-12">
              <label>Comprobante: {{ model.FormatttedReceipt }}</label>
            </div>
            <div class="col-md-12">
              <label>Importe: {{ model.FormatttedAmount }}</label>
            </div>
          
        </div>
        <div>
          <div class="row text-left" style="margin-top: 10px">
            <div class="col-md-6">
              <b-button class="btn btn-lg btn-danger" @click="goBack"
                >Volver</b-button
              >
            </div>
            <div class="col-md-6 text-right">
              <save-button
                text="Reversar carga"
                @click="reverseRecharge"
              ></save-button>
            </div>
          </div>
        </div>
      </b-card-body>

      <b-card-body v-if="model.viewResult">
        <div class="row">
          <div class="col-md-12 text-center">
            <base-alert :type="resultado.Tipo">
              <span class="alert-inner--icon" style="font-size: 60px">
                <i :class="resultado.Icono"></i> </span
              ><br />
              <span class="alert-inner--text" v-html="resultado.Texto"></span>
            </base-alert>
          </div>
          <div class="col-md-12">
            <div class="row text-center" style="margin-top: 10px">
              <div class="col-md-12">
                <b-button class="btn btn-lg btn-danger" @click="goBack"
                  >Volver</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style>
</style>

<script>
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import axiosHelpers from "@/helpers/axiosHelpers";

export default {
  components: {},
  data() {
    return {
      model: {
        DateTime: null,
        ReceiptID: null,
        Amount: 0,
        IsFirtsCharge: true,
        IsNotFirtsCharge: false,
        FormatttedDateTime: "",
        FormatttedReceipt: "",
        FormatttedAmount: "",
        viewResult: false,
        QueueID: 0
      },
      resultado: {
        Texto: "",
        Tipo: "success",
        Icono: "fa fa-fw fa-thumbs-up",
      },
    };
  },
  methods: {
    filtrar() {
      let context = this;
      var req = {};
      axiosHelpers.axiosPost("Mastercard/LastCharge", req, this, function (
        data
      ) {
        context.model.DateTime = data.ResponseVM.DateTime;
        context.model.ReceiptID = data.ResponseVM.ReceiptID;
        context.model.Amount = data.ResponseVM.Amount;
        context.model.IsFirtsCharge = data.ResponseVM.IsFirtsCharge;
        context.model.IsNotFirtsCharge = data.ResponseVM.IsNotFirtsCharge;
        context.model.FormatttedDateTime = data.ResponseVM.FormatttedDateTime;
        context.model.FormatttedReceipt = data.ResponseVM.FormatttedReceipt;
        context.model.FormatttedAmount = data.ResponseVM.FormatttedAmount;
        context.model.QueueID = data.ResponseVM.QueueID;

        if (context.model.IsFirtsCharge) {
          context.model.viewResult = true;
          context.resultado = {
            Texto: "No tiene cargas a reversar",
            Tipo: "danger",
            Icono: "fa fa-fw fa-thumbs-down",
          };
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    reverseRecharge() {
      let context = this;
      var req = { QueueID: context.model.QueueID };
      axiosHelpers.axiosPost(
        "Mastercard/ReverseLastCharge",
        req,
        this,
        function (data) {
            context.model.viewResult = true;
          if (data.Alerts.length == 0) {
            if (data.ResponseVM.Result) {
              let msg = "La reversa se realizo correctamente";

              context.resultado = {
                Texto: msg,
                Tipo: "success",
                Icono: "fa fa-fw fa-thumbs-up",
              };
            } else {
              context.resultado = {
                Texto:
                  "La reversa fue rechazada",
                Tipo: "danger",
                Icono: "fa fa-fw fa-thumbs-down",
              };
            }
          } else 
          {
            context.resultado = 
            {
              Texto: data.Alerts[0].Message,
              Tipo: "danger",
              Icono: "fa fa-fw fa-thumbs-down",
            };
          }
        }
      );
    }
  },
  beforeMount: function () {
    let context = this;

    context.filtrar();
  }
};
</script>